import React from 'react';
import Link from './Link';
import BorderPicture, { BorderPictureProps } from './BorderPicture';

export interface CardOverlayProps
{
    picture: BorderPictureProps;
    title: string;
    content?:string;
    actionUrl?:string;
    actionName: string;
}

const CardOverlay = (props: CardOverlayProps) => {
    return (
                <div className="justify-around bg-white rounded-2xl">
                <BorderPicture {...props.picture}></BorderPicture>
                <h2 title={props.title} className="text-lg md:text-base xl:text-xl font-bold text-black uppercase my-4" dangerouslySetInnerHTML={{ __html: props.title }}></h2>
                {props.content && <p>{props.content}</p>}
                {props.actionUrl && 
                    <Link classname="bg-purple text-white text-center text-xs p-2 uppercase text-opacity-50 block rounded-2xl" target="" url={props.actionUrl} name={props.actionName} title={props.actionName}></Link>
                }
                </div>
            )
}

export default CardOverlay;